import type {SeedQuestion, SeedQuestionSource} from '@cp/model';
import createSeedQuestionDoc from '../../api/seedQuestion/createSeedQuestionDoc';
import {useFunctionWrap} from '../helper/function/useFunctionWrap';

export function useCreateSeedQuestion() {
  const {
    fn: createSeedQuestion,
    loading,
    error,
  } = useFunctionWrap(
    async (
      moduleId: string,
      questionText: string,
      topic: string,
      options: string[],
      answer: string,
      source: SeedQuestionSource,
    ): Promise<SeedQuestion> => createSeedQuestionDoc(moduleId, {questionText, topic, options, answer, source}),
  );

  return {
    createSeedQuestion,
    loading,
    error,
  };
}
